import {
  DEFAULT_REFRESH_CART_VALUES,
  useCartContext,
} from '@/app/contexts/CartProvider';
import useDisplayAffirm from '@/app/hooks/useDisplayAffirm';
import type { ProductDiscountedPriceFragment } from '@/queries/fragments/ProductFragment';

import isAccessory from '../_utils/isAccessory';
import isFreeRing from '../_utils/isFreeRing';

/**
 * Returns whether or not affirm messaging should be displayed on the PDP
 * */
const useShowPDPAffirmMessage = (
  discountedProductPrice: ProductDiscountedPriceFragment | undefined,
  handle: string | undefined,
): boolean => {
  const isEnabledUSOnly = useDisplayAffirm();
  const { refreshCart } = useCartContext();
  const cart =
    refreshCart?.cart?.refreshCart.cart ??
    DEFAULT_REFRESH_CART_VALUES.cart!.refreshCart.cart!;
  const ringCount = cart.ringCount!;

  if (!discountedProductPrice || !handle) return false;

  const isFree = isFreeRing(discountedProductPrice);
  const isRing = !isAccessory(handle);
  const hasRings = ringCount > 0;

  return !isFree && isRing && isEnabledUSOnly && !hasRings;
};

export default useShowPDPAffirmMessage;
